import {
  ButtonGroup,
  Grid,
  GridItem,
  PhoneNumberInputField,
  PrimaryButton,
} from "@certn/cascadia-react";
import { phoneNumberSchema } from "@certn/cascadia-react/components/inputs/phone-number/schema";
import { Field, Form, Formik } from "formik";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { SettingsEditItem } from "../../../components/Settings/SettingsEditItem";
import { useFormSubmit } from "../../../hooks/api/useSubmit";
import { useUser } from "../../../hooks/api/useUser";

export function PhoneSettings() {
  const { t } = useTranslation();
  const { user, mutate } = useUser();
  const [expanded, setExpanded] = useState(false);
  const toggle = () => setExpanded((curr) => !curr);

  const handleSubmit = useFormSubmit(
    "/internal/people/me/phone-number/update/",
    {
      onSuccess: () => {
        toggle();
        mutate();
      },
    }
  );

  const defaultValues = {
    phone_number: {
      number: "",
      national_number: "",
      country: "",
      calling_code: "",
    },
  };

  const primaryPhoneNumber = user?.personal_profile?.profile_phone_numbers[0];
  const initialValues = primaryPhoneNumber
    ? {
        phone_number: primaryPhoneNumber,
      }
    : defaultValues;

  const number = user?.personal_profile?.profile_phone_numbers[0]?.number;

  return (
    <SettingsEditItem
      setting={t("Phone number")}
      value={number || "-"}
      description={t("To receive help logging in and for notifications.")}
      expanded={expanded}
      toggle={toggle}
      testID={expanded ? "phone-number-cancel-link" : "phone-number-edit-link"}
    >
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validationSchema={phoneNumberSchema}
      >
        <Form>
          <Grid width="416px">
            <GridItem>
              <Field
                name="phone_number"
                label={t("Phone number")}
                as={PhoneNumberInputField}
                isRequired
              />
            </GridItem>
            <GridItem>
              <ButtonGroup>
                <PrimaryButton
                  type="submit"
                  size="medium"
                  testID="phone-number-save-button"
                >
                  {t("Save")}
                </PrimaryButton>
              </ButtonGroup>
            </GridItem>
          </Grid>
        </Form>
      </Formik>
    </SettingsEditItem>
  );
}
